import { useViewport } from 'components/general/useViewPort';
import React, { useMemo } from "react";
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import { ColumnExpander, ColumnNameH2H } from "components/common/TableColumns"
import StatsBox from "components/sports/wpo/components/StatsBox"
import { dateFormat } from "helpers/utils"
import { findArray } from 'helpers/utils'
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import { capitalizeFirstLetter } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const TableColumns = (breakPoint) => {
  return (
    [
      ColumnBib({}),
      ColumnNameH2H({ showCaptainAbbr: true, showSuspendedCode: false, hideNoc: true }),
      ColumnPosition({ breakPoint: breakPoint }),
      ColumnExpander({ type: 'alwaysTrue', idNode: 'athlete' })
    ]
  )
}

export function ColumnBib({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-5 text-nowrap',
  label = 'HeaderNumber',
  remove = false
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'bib',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: 'Bib',
      remove: remove,
      Cell: props => {
        const row = props.cell.row.original;
        const isSuspended = row?.eventUnitEntries?.find(e => e?.eue_code === 'STATUS')?.eue_value === 'SUSPEND';
        return isSuspended ? '(S)' : row?.bib;
      }
    }
  )
}

export function ColumnPosition({
  disableSort = true,
  className = 'text-start',
  headerClassName = 'text-start w-10',
  label = 'HeaderPosition',
  code = 'Position',
  breakPoint = ''
}) {
  const isMobile = breakPoint === 'sm' || breakPoint === 'xs'; 
  return (
    {
      Header: <Label data={label} />,
      accessor: 'functionDescription',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: code,
      Cell: props => {
        const row = props.cell.row.original;
        const xs = row?.eventUnitEntries?.find(e => e?.eue_code === 'POSITION')?.eue_value;
        const xl = row?.functionDescription
        return isMobile ? xs : xl
      }
    }
  )
}

const getConfigurationBox = (date) => {

  const formatedDate = date ? dateFormat(date, "", "D MMM H:mm") : "";

  let configuration = {
    header: <><Label data="HeaderTournamentStats" /> - {formatedDate}</>,
    stats: [
      {
        order: 1,
        code: 'TOTAL',
        attr: 'value',
        label: 'stat_1',
        title: 'Goals'
      },
      {
        order: 2,
        code: 'PF',
        attr: 'value',
        label: 'stat_2',
        title: 'Personal Fouls'
      },
      {
        order: 3,
        code: 'MINS',
        attr: 'value',
        label: 'stat_3',
        title: 'Average Minutes Played'
      }
    ]
  }
  return configuration;
}

const getConfiguration = (data, breakPoint) => {
  let configuration = {
    columns: [],
    subComponent: null,
    caption: null,
    hiddenColumns: [],
    sortBy: [],
    configs: {
    }
  };

  configuration.caption = (<>
      <div className='d-flex align-items-center'>
        <div className='d-none d-md-block me-1'>
          <Noc className='me-1' {...data?.participant?.organisation} />
        </div>
        <strong>
          <Competitor hidePicture={true} {...data?.participant}/>
        </strong>
        <div className='ms-3'>
          <Uniform data={data} />
        </div>
      </div>
    </>)

    configuration.columns = TableColumns(breakPoint);


  return configuration;
}

const Uniform = ({ data }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  const uniform = capitalizeFirstLetter(data?.eventUnitEntries?.find(i => i?.eue_code === 'UNIFORM')?.eue_value?.toLowerCase());
  return <Label data={`Label${uniform}`} sport={mirs_discipline} />;
}

const StartListSide = ({ data, resultStatus, config, date }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();

  const configEvent = useMemo(() => getConfiguration(data, breakPoint));

  const configBox = useMemo(() => getConfigurationBox(date));

  const renderRowSubComponent = React.useCallback(({ row }) => (
    <LoaderSubComponent component={
      <StatsBox data={row?.original} config={configBox} breakPoint={breakPoint} />
    }
    />
  ), [resultStatus]);

  return (<>
    {data.teamAthletes && (
      <div className="start-list-side-main">
            <MirsTable
              className={"table-start-list"}
              id={`mirs-table-start-list-starters-${mirs_rsc}-${data?.participant?.code}`}
              data={data?.teamAthletes}
              columns={configEvent.columns}
              renderRowSubComponent={renderRowSubComponent}
              keyRow='athlete-code'
              caption={configEvent.caption}
              initialSortBy={configEvent.sortBy}
            />
        </div>
    )
    }
  </>)
}

export default StartListSide;
